var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('youtube',{ref:"youtube",attrs:{"video-id":_vm.video,"player-vars":{ rel: 0 },"resize":true},on:{"playing":_vm.playing}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }